export default {
  items: [],
  loading: false,
  sort: {
    page: 1,
    column: 'formation_name',
    order: 'ascending',
    limit: 0,
    filter: '',
  },
  total: 0,
};
